import { writable } from 'svelte/store';

// This store will hold the notification data.
// It is subscribed to by the Notification component.
export const notificationStore = writable(null);